import { useQuery, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';

// Our axios Instance
import axiosInstance from 'services/API/API';

// Our Query Keys
import { FA_DASHBOARD_PAGINATED_SUMMARY } from 'shared/query-keys';

// Our End points
import { faSummaryV2 } from 'shared/api-urls';

// Our Routes
import { LOGIN_ROUTE } from 'routes/index';

const PAGE_SIZE = 10;

const getNextPageOffset = (pageNumber) => {
	const offset = pageNumber * PAGE_SIZE;
	return offset;
};

const fetchPage = async (pageNumber, searchQuery) => {
	const params = {
		offset: getNextPageOffset(pageNumber),
		pagesize: PAGE_SIZE,
		q: searchQuery
	};

	const response = await axiosInstance.get(faSummaryV2, {
		params
	});

	return response.data.data;
};

function useGetFaPaginatedSummary(pageNumber, searchQuery) {
	const queryClient = useQueryClient();
	const navigate = useNavigate();
	const params = {
		offset: getNextPageOffset(pageNumber),
		pagesize: PAGE_SIZE,
		q: searchQuery
	};

	return useQuery(
		[FA_DASHBOARD_PAGINATED_SUMMARY, pageNumber],
		async () => {
			const data = await fetchPage(pageNumber, searchQuery);
			const moreClientsThanPageSize = data.totalClient > PAGE_SIZE;

			if (moreClientsThanPageSize) {
				try {
					const finalPageIndex =
						Math.ceil(data.totalClient / PAGE_SIZE) - 1;

					if (pageNumber !== finalPageIndex) {
						const nextThreePages = Array.from(
							{
								length: Math.min(3, finalPageIndex - pageNumber)
							},
							(_, index) => pageNumber + index + 1
						);

						nextThreePages.forEach((page) => {
							queryClient.prefetchQuery(
								[FA_DASHBOARD_PAGINATED_SUMMARY, page],
								() => fetchPage(page, searchQuery)
							);
						});
					}
				} catch (error) {
					console.log(error);
				}
			}

			return data;
		},
		{
			onError: (error) => {
				navigate(LOGIN_ROUTE);
			},

			meta: params
		}
	);
}

export default useGetFaPaginatedSummary;
